import PredictionDetails from './PredictionDetails';

export default PredictionDetails;
